import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Card,
  Grid,
  InputLabel,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Typography,
  FormLabel,
  RadioGroup,
  FormHelperText,
  Radio,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import { mobileOtpThunk, verifyOtpThunk } from "./reducer/thunk.js";
import Methods from "../../utility/Methods.js";
import Colors from "../../utility/Colors.js";
import OtpVerification from "../../components/otpVerification/otpVerification.js";
import { useNavigate } from "react-router-dom";
import { getSession, setLoginDetails } from "../../utility/SessionManager.js";
import constants from "../../common/constants.js";
import { Box } from "@mui/system";
import OtpInput from "react-otp-input";
import BackdropComponent from "../../components/backdrop/index.tsx";
import { resetMobileOtp, resetVerifyOtp } from "./reducer/slice.js";

const AbhaLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOTP, setShowOTP] = useState(false);
  const [abhaNumber, setAbhaNumber] = useState("");
  const [verificationType, setVerificationType] = useState("");
  const [OTP, setOTP] = useState("");
  const [txnId, setTxnId] = useState("");
  const [message, setMessage] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const mobileOtp = useSelector((state) => state.login.mobileOtp);
  const {
    status: mobileOtpStatus,
    data: mobileOtpData,
    error: mobileOtpError,
  } = mobileOtp;
  const verifyOtp = useSelector((state) => state.login.verifyOtp);
  const {
    status: verifyOtpStatus,
    data: verifyOtpData,
    error: verifyOtpError,
  } = verifyOtp;
  const { loading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (mobileOtpStatus === "succeeded") {
      console.log("enc res", mobileOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(mobileOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(mobileOtpData?.data));
      console.log("test ", decData.response);
      let finalData = decData.response;
      setTxnId(finalData?.txnId);
      setMessage(finalData?.message);
      setShowOTP(true);
      handleShowSnackbar("success", "OTP sent successfully!");
    } else if (mobileOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(mobileOtpError));
      // console.log("verifyOtp data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [mobileOtpStatus]);

  useEffect(() => {
    if (verifyOtpStatus === "succeeded") {
      console.log("enc res", verifyOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(verifyOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(verifyOtpData?.data));
      console.log("verifyOtp data", decData.response);
      let finalData = decData.response;
      if (finalData?.authResult === "failed") {
        handleShowSnackbar("error", finalData?.message);
      } else if (finalData?.authResult === "success") {
        setLoginDetails(finalData);
        navigate(constants.PATH_DASHBOARD);
        navigate("/dashboard");
        handleShowSnackbar("success", "OTP verified successfully!");
      }
    } else if (verifyOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(verifyOtpError));
      // console.log("verifyOtp data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [verifyOtpStatus]);

  useEffect(() => {
    if (getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)) {
      navigate(constants.PATH_DASHBOARD);
    }
  }, [navigate]);
  useEffect(() => {
    window.scrollTo(0, 0);
    // Reset Redux state on mount to prevent stale state
    dispatch(resetVerifyOtp());
    dispatch(resetMobileOtp());
  }, []);

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity,
      message,
    });
  };

  const handleSnackClose = () => {
    setSnackbarOpen({
      open: false,
      severity: "",
      message: "",
    });
  };

  const validationSchema = Yup.object({
    abhaNumber: Yup.string()
      .matches(/^\d{14}$/, "Enter a valid 14-digit ABHA number")
      .required("ABHA number is required"),
    verificationType: Yup.string().required("Select an option"),
  });

  const dashedAbhaNumber = (num) => {
    const input = num;

    // Convert string to array of characters
    let chars = input.split("");

    // Insert hyphens at desired positions
    chars.splice(2, 0, "-"); // After 32nd character
    chars.splice(7, 0, "-"); // After 6th character (index shifted due to previous insert)
    chars.splice(12, 0, "-"); // After 6th character (index shifted due to previous insert)

    // Join back to string
    const output = chars.join("");

    return output;
  };

  const handleSubmitData = async (data) => {
    let finalAbha = dashedAbhaNumber(data?.abhaNumber);
    console.log("data", data);
    setAbhaNumber(finalAbha);
    setVerificationType(data?.verificationType);
    const reqObj = {
      loginId: finalAbha || "",
      loginHint: "abha-number",
      txnId: "",
      scope: data?.verificationType,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log("decrypted object", Methods.decryptObject(finalReqObj));
    dispatch(mobileOtpThunk(finalReqObj));
  };

  const handleVerifyOtp = (otp) => {
    setOTP(otp);
    let reqObj = {
      txnId: txnId,
      otp: otp,
      scope: verificationType,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log(
      "decrypted object verify otp",
      Methods.decryptObject(finalReqObj)
    );
    dispatch(verifyOtpThunk(finalReqObj));
  };

  const handleResendOtp = () => {
    const reqObj = {
      loginId: abhaNumber || "",
      loginHint: "abha-number",
      txnId: "",
      scope: verificationType,
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    dispatch(mobileOtpThunk(finalReqObj));
  };

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "100%",
          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        {mobileOtpStatus === "pending" && <BackdropComponent />}
        {verifyOtpStatus === "pending" && <BackdropComponent />}
        {!showOTP ? (
          <Formik
            initialValues={{ abhaNumber: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleSubmitData(values);
            }}
          >
            {(props) => (
              <Form>
                <Grid container spacing={4} sx={{ p: 1 }}>
                  {[
                    {
                      name: "abhaNumber",
                      label: "ABHA Number",
                      type: "input",
                      required: true,
                    },
                    {
                      name: "verificationType",
                      label: "Validate Using",
                      type: "radio",
                      required: true,
                      options: [
                        {
                          label:
                            "OTP on mobile number linked with Aadhaar number",
                          value: "aadhaar-verify",
                        },
                        {
                          label: "OTP on mobile number linked with ABHA number",
                          value: "mobile-verify",
                        },
                      ],
                    },
                  ].map((field) => (
                    <>
                      {field?.type === "input" ? (
                        <Grid item size={{ xs: 12, md: 12 }} key={field.name}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <>
                                <InputLabel
                                  htmlFor={field.label}
                                  sx={{ mb: 2 }}
                                >
                                  Enter ABHA Number
                                </InputLabel>

                                <OtpInput
                                  value={props.values[field.name]}
                                  onChange={(value) =>
                                    props.setFieldValue(field.name, value)
                                  }
                                  numInputs={14}
                                  isInputNum
                                  shouldAutoFocus
                                  containerStyle={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "0.5rem",
                                  }}
                                  inputStyle={{
                                    width: "2.5rem",
                                    height: "3rem",
                                    fontSize: "1.5rem",
                                    borderRadius: 4,
                                    border: "1px solid #ccc",
                                    textAlign: "center",
                                  }}
                                  renderSeparator={(index) =>
                                    index === 1 ||
                                    index === 5 ||
                                    index === 9 ? (
                                      <span
                                      // style={{
                                      //   margin: "0 0.5rem",
                                      //   fontWeight: "bold",
                                      // }}
                                      >
                                        -
                                      </span>
                                    ) : null
                                  }
                                  renderInput={(inputProps, index) => (
                                    <input
                                      {...inputProps}
                                      key={index}
                                      maxLength={1}
                                      autoComplete="one-time-code"
                                      onFocus={(e) => e.target.select()}
                                    />
                                  )}
                                />
                              </>
                            )}
                          </Field>
                        </Grid>
                      ) : field?.type === "radio" ? (
                        <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <>
                                <FormLabel component="legend">
                                  {field.label}
                                </FormLabel>
                                <RadioGroup
                                  name={field.name}
                                  defaultValue={field.defaultValue || ""}
                                  row
                                >
                                  {field.options.map((option) => (
                                    <FormControlLabel
                                      key={option.value}
                                      value={option.value}
                                      required
                                      control={<Radio />}
                                      onChange={(e) => {
                                        console.log("hiehgj", e);
                                        props.setFieldValue(
                                          field.name,
                                          e.target.value
                                        );
                                      }}
                                      label={option.label}
                                    />
                                  ))}
                                </RadioGroup>
                                {meta.touched && meta.error && (
                                  <FormHelperText error>
                                    {meta.error}
                                  </FormHelperText>
                                )}
                              </>
                            )}
                          </Field>
                        </Grid>
                      ) : null}
                    </>
                  ))}
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{ p: 1 }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    sx={{
                      cursor: "pointer",
                      background:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : "rgb(245, 132, 31)",
                      color:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : Colors.WHITE,
                      px: 6,
                      my: 5,
                      borderRadius: "5px",
                      "&:hover": { opacity: 0.9 },
                    }}
                    type="submit"
                    disabled={!(props.isValid && props.dirty)}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Next"
                    )}
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        ) : (
          <OtpVerification
            onVerify={handleVerifyOtp}
            onResend={handleResendOtp}
            message={message}
          />
        )}

        <SnackbarComponent
          message={snackbarOpen?.message}
          isOpen={snackbarOpen?.open}
          purpose={snackbarOpen?.severity}
          handleClick={handleSnackClose}
        />
      </Card>
    </div>
  );
};

export default AbhaLogin;
